

function FormError({children}) {
  return (
    <div style={{color: 'red'}} className='form-err'>{children}</div>
  )
}

export default FormError